// src/api/castingApi.js

const API_URL =
  'https://api.opencurtainscasting.com/casting/getCastingAllImageDetails';

/**
 * Fetch casting images from API
 * @returns {Promise<Array<{ imageUrl: string, websiteUrl: string }>>}
 */
export const fetchCastingImages = async () => {
  try {
    const response = await fetch(API_URL);
    const data = await response.json();

    if (data.success && data.castings) {
      return data.castings.map((casting) => ({
        imageUrl: casting.imageURL,
        websiteUrl: casting.websiteURL.startsWith('http')
          ? casting.websiteURL
          : `https://${casting.websiteURL.replace(/^htts/, 'https')}`,
      }));
    } else {
      console.error('API response invalid:', data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching casting images:', error);
    return [];
  }
};
